import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  redirect() { Turbo.visit(this.element.value) }
}
